import { IThreeDSecureProviderContractCreate } from './three-d-secure-provider-contract-create.interface';

export type IThreeDSecureProviderContractUpsert = IThreeDSecureProviderContractCreate & {
  name?: IThreeDSecureProviderContractCreate['name'];
};
